import VariantImages from '@/assets/VariantImages'
import { AnimalSpecies } from '@/dataV3/Animal/AnimalSpecies'
import { CreateAnimal } from '@/modules/User/apiTypes/ContinueRegister'
import { convertToAPIReadyBase64Async } from '@/utils'

const getDefaultImage = async (species: AnimalSpecies) => {
  let img: typeof VariantImages.DefaultDog | typeof VariantImages.DefaultCat | typeof VariantImages.DefaultNac | null =
    null

  switch (species) {
    case AnimalSpecies.dog:
      img = VariantImages.DefaultDog
      break
    case AnimalSpecies.cat:
      img = VariantImages.DefaultCat
      break
    case AnimalSpecies.nac:
      img = VariantImages.DefaultNac
      break
    default:
      img = null
  }

  if (img) {
    return await convertToAPIReadyBase64Async(img.default.src, true)
  }
  return null
}

export const buildFakeAnimalBody = async (species: AnimalSpecies = AnimalSpecies.dog): Promise<CreateAnimal.Body> => {
  const mainPicture = await getDefaultImage(species)

  return {
    fakeAnimal: true,
    speciesSlug: species,
    displayName: 'FakeAnimal',
    breedSlug: 'autre',
    sizeSlug: 'little',
    birthDate: new Date('2020-01-01').toISOString(),
    gender: 'male',
    mainPicture,
    animalPictures: [],
    description:
      "La description de cet animal n'a pas été donnée par son propriétaire. Si vous en avez besoin, vous pouvez l'encourager à vous donner une description via la messagerie.",
    animalOptions: {
      niceWithChildren: true,
      niceWithDogs: true,
      niceWithCats: true,

      entrustFewHours: true,
      entrustDayNight: false,
      entrustWeekendHoliday: false,

      availabilityWeekDay: true,
      availabilityWeekNight: false,
      availabilityWeekend: false,

      needTrips: true,
      needExercise: true,
      needPlay: true,
      needKeep: false,
      needTakeCare: false,
      needLove: true,

      sterilized: true,
      displayToBorrowers: true,
    },
  }
}
